(function () {
  $(document).ready(function () {
    // In order for the form to be submitted correctly AND look good
    // we need to hide inputs check box, but we also need the ability
    // to click on it, and update its value.
    // The parent div button here is clicked, the button callback changes the value
    // of the child input, and also triggers the function callback for the input below.

    // hiding skeleton placeholders once react summary renders
    $(".skeleton-placeholder").hide();
    const coverageNeeded = $("input[name=priming_upsell_gl_plus]");

    if (coverageNeeded.is(":visible") && !$("body").hasClass("backoffice")) {
      if ($(".upsell-page").length > 0) {
        $(".site-section.grid-wrapper").addClass("questionnaire");
      }

      const sumInsured = $("#gl_plus_sum_insured");
      const sumInsuredInput = $("#GL_plus_sum_insured");
      const coverageChecked = $("input[name=priming_upsell_gl_plus]:checked");
      if (coverageChecked.val() === "yes") {
        sumInsured.show();
      } else {
        sumInsured.hide();
      }

      if ($(".upsell-consider-label").length === 0) {
        $("#gl_plus_sum_insured").prepend(
          "<p class='upsell-consider-label'>Then you might want to consider adding...</p>",
        );
      }
      if (sumInsuredInput.val() !== "0") {
        $("#priming_upsell_gl_plus_yes").prop("checked", "true");
        sumInsured.show();
      }

      $("input[name=priming_upsell_gl_plus]").on("click", () => {
        const sumInsuredInput = $("#GL_plus_sum_insured");
        const sumInsured = $("#gl_plus_sum_insured");
        const coverageChecked = $("input[name=priming_upsell_gl_plus]:checked");

        if (coverageChecked.val() === "yes") {
          window.EventTracker?.trigger("selected_upsell_oppurtunity");
          sumInsured.show();
        } else {
          window.EventTracker?.trigger("not_selected_upsell_oppurtunity");
          sumInsured.hide();
          if (sumInsuredInput.val() !== "0")
            sumInsuredInput.val("0").trigger("change");
        }
      });
    } else {
      $("#priming_upsell_gl_plus").hide();
    }

    function toggleButton(inputElement, buttonElement) {
      const labelText = buttonElement.find(".upsell-question__button-label-js");

      // Toggle the answer value
      const newAnswerValue = inputElement.val() === "yes" ? "no" : "yes";
      const newAnswerLabel = $(
        `.upsell-question__${newAnswerValue}-label-js`,
      ).html();

      labelText.html(newAnswerLabel);
      inputElement.val(newAnswerValue);

      buttonElement.toggleClass("upsell-question__button--activated");
    }

    function submitUpsellChanged(input, onFailureResetSelection) {
      const pricingHtml = $(".persistent_price_summary").html();
      const spinner = $(".upsell-pricing__loading-spinner");
      spinner.addClass("upsell-pricing__loading-spinner--activated");
      $(".upsell-pricing__row-js").remove();

      const form = input.closest("form");
      const url = form.attr("action");
      const endpointParams = `${url.indexOf("?") === -1 ? "?" : "&"}step_action=change_upsell`;

      const request = $.ajax({
        type: "POST",
        url: `${url}${endpointParams}`,
        data: form.serialize(),
        dataType: "json",
        context: this,
      });

      request.done(function (data) {
        $(".upsell-page__error-js").html(" ");
        $(".shopping-cart-img").addClass("updated-cart");
        if (data.consultant) {
          $(".persistent_product_summary").html(data.product_summary);
          $(".persistent_price_summary").html(data.pricing);
        } else {
          $(".coverage_summary").html(data.coverage_summary_view_model);
        }
      });

      request.fail(function () {
        $(".upsell-page__error-js").html(
          "Something went wrong. Please refresh the page and try again.",
        );

        onFailureResetSelection();

        $(".persistent_price_summary").html(pricingHtml); // replace the spinner with memoized price
      });
    }

    $(".upsell-question__button-js").click(function (_) {
      const button = $(this);
      const input = button.find("input.upsell-question__input-js");
      toggleButton(input, button);
      input.click();
    });

    $(".upsell-question__input-js").focusin(function (_) {
      const input = $(this);
      const button = input.parent();
      button.addClass("upsell-question__button--focus");
    });

    $(".upsell-question__input-js").focusout(function (_) {
      const input = $(this);
      const button = input.parent();
      button.removeClass("upsell-question__button--focus");
    });

    $(".upsell-question__input-js").click(function (event) {
      // Prevent a feedback loop with the button listener
      event.stopPropagation();
      const input = $(this);
      // Explicitly check this input so that it is included in serialized payload.
      input.prop("checked", true);

      const onFailureResetSelection = function () {
        toggleButton(input, input.parent());
      };

      submitUpsellChanged(input, onFailureResetSelection);
    });

    $(".upsell-question__select-js").change(function (event) {
      // Prevent a feedback loop with the button listener
      event.stopPropagation();
      const input = $(this);

      const onFailureResetSelection = function () {
        $('.upsell-question__select-js option[value="0"]').prop(
          "selected",
          "selected",
        );
      };

      submitUpsellChanged(input, onFailureResetSelection);
    });

    $(".upsell-question__select-js").change(function () {
      const dropdownName = $(this)[0].name;
      const selectedValue = $(this).children(":selected").html();
      window.EventTracker?.trigger(
        "upsell_dropdown_clicked",
        dropdownName,
        selectedValue,
      );
    });

    $(".upsell-question__input-js").click(function (event) {
      const elementName = event.target.name;
      window.EventTracker?.trigger("upsell_button_clicked", elementName);
    });

    $(".upsell__questionnaire button.js-next-button").click(function () {
      const products = $(".upsell-question")
        .toArray()
        .reduce((acc, curr) => {
          const element = $(curr).find("input, select");
          const value = element.val();
          if (value !== "no" && value !== "0") {
            let product = element.attr("name");
            if (value !== "yes") {
              product += ` - ${value}`;
            }
            acc.push(product);
          }
          return acc;
        }, []);

      window.EventTracker?.trigger("upsell_selected", products);
    });
  });
}).call(this);
